<template>
  <GlobalWindow
    :visible.sync="isVisibled"
    :show="true"
    title="绑定广告主"
    width="80%"
    @confirm="confirm"
    @close="close"
  >
    <div class="top">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-input
            v-model="parameter.keyword"
            placeholder="请输入广告主名称"
            @input="handleParams"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
            />
          </el-input>
        </el-col>
        <el-button
          type="primary"
          @click="search"
        >搜索</el-button>
        <el-button
          type="primary"
          @click="reset"
        >重置</el-button>
        <el-button
          type="primary"
          @click="clearSelect"
        >清空选项</el-button>
      </el-row>
    </div>

    <div class="center-container">
      <div class="center-left">
        <!-- :row-key="getRowKeys" -->
        <el-table
          v-if="datas"
          ref="multipleTable"
          v-loading="isLoading"
          :data="datas"
          border
          :row-key="getRowKeys"
          tooltip-effect="dark"
          @select="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          />
          <el-table-column
            prop="account_id"
            label="account_id"
          />
          <el-table-column
            prop="account_name"
            label="广告主名称"
            show-overflow-tooltip
          />
          <el-table-column label="日期" width="350">
            <template scope="scope">

              <div v-if="myActives.filter(item => +item.account_id === +scope.row.account_id).length" style="display: flex;">
                <div>
                  <div
                    v-for="index in myActives.filter(item => +item.account_id === +scope.row.account_id)[0].control ? myActives.filter(item => +item.account_id === +scope.row.account_id)[0].date.length : 1"
                    :key="index"
                    style="display: flex; align-items: center;"
                  >
                    <el-date-picker
                      v-model="myActives.filter(item => +item.account_id === +scope.row.account_id)[0].date[index-1]"
                      size="mini"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />

                    <!-- 删除按钮 -->
                    <i
                      v-if="index > 1"
                      class="el-icon-circle-close"
                      style=" font-size: 18px; margin-left: 9px; cursor: pointer;"
                      @click="deleteDate(scope.row.account_id, index)"
                    />

                    <!-- 占位 -->
                    <i v-else class="el-icon-circle-close" style=" font-size: 18px; margin-left: 9px; cursor: pointer; opacity: 0;" />
                  </div>

                  <!-- 无限大 -->
                  <div v-if="myActives.filter(item => +item.account_id === +scope.row.account_id)[0].control" class="infinite">
                    <el-date-picker
                      v-model="myActives.filter(item => +item.account_id === +scope.row.account_id)[0].infiniteStart"
                      type="date"
                      size="mini"
                      placeholder="开始日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                    <span style="display: inline-block; margin-left: 16px;">结束: 至今</span>
                  </div>

                  <!-- 省略号图标 -->
                  <i v-if="!myActives.filter(item => +item.account_id === +scope.row.account_id)[0].control" class="el-icon-more" />
                  <!-- !myActives.filter(item => +item.account_id === +scope.row.account_id)[0].control && myActives.filter(item => +item.account_id === +scope.row.account_id)[0].date.length > 1 -->

                </div>

                <i
                  class="el-icon-remove-outline additionAndSubtraction"
                  @click="processingMultipleTimes(scope.row.account_id, 'reduce')"
                />
                <i
                  class="el-icon-circle-plus-outline additionAndSubtraction"
                  @click="processingMultipleTimes(scope.row.account_id, 'plus')"
                />
                <i
                  class="additionAndSubtraction"
                  :class="{
                    'el-icon-arrow-down': myActives.filter(item => +item.account_id === +scope.row.account_id)[0].control,
                    'el-icon-arrow-right': !myActives.filter(item => +item.account_id === +scope.row.account_id)[0].control
                  }"
                  @click="myActives.filter(item => +item.account_id === +scope.row.account_id)[0].control = !myActives.filter(item => +item.account_id === +scope.row.account_id)[0].control"
                />

              </div>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="myActives.length" style="margin-left:20px; max-height: 594px; overflow: auto;">
        <el-table
          :data="myActives"
          border
        >
          <el-table-column
            prop="account_name"
            label="广告主名称"
          >
            <template scope="scope">
              <span style="overflow:hidden; white-space: nowrap; text-overflow: ellipsis;" :title="scope.row.account_name">{{ scope.row.account_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="account_id"
            label="account_id"
            width="100"
          />
          <el-table-column label="日期" width="220">
            <template scope="scope">
              <p style="white-space: break-spaces;">
                {{
                  scope.row.date.filter((item,index) =>{
                    return
                    scope.row.control1 ? item && item.length > 1 : item && item.length > 1 && index === 0}).map(item => item[0] + '---' + item[1]).join('\n')
                }}
              </p>
              <span v-if="scope.row.control1 && scope.row.infiniteStart">{{ scope.row.infiniteStart + ' --- 至今' }}</span>

              <!-- 控制展开和收起 -->
              <i
                :class="{
                  'el-icon-arrow-down': scope.row.control1,
                  'el-icon-arrow-right': !scope.row.control1
                }"
                style="position: absolute; top: 14px;right: 5px; font-size: 15px;cursor: pointer;"
                @click="scope.row.control1 = !scope.row.control1"
              />

              <!-- 省略号图标 -->
              <i v-if="!scope.row.control1 && (scope.row.date.length > 1 || scope.row.infiniteStart)" class="el-icon-more" />
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>

    <Pagination
      :total="total"
      :page.sync="parameter.page"
      :limit.sync="parameter.page_size"
      :auto-scroll="false"
      @pagination="fetchAvertiserList"
    />
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow.vue'
import Pagination from '@/components/Pagination/index'
import { bindAdvertisers, advertiserList, getTheAccountNumber } from '@/api/providerAccountManagement/WeChatAccountFans'
export default {
  name: 'CopyAdqAdDialog',
  components: {
    GlobalWindow,
    Pagination
  },
  props: {
    id: {},
    type: {},
    actives: {},
    identical: {}
  },
  data() {
    return {
      isVisibled: true,
      isLoading: false,
      total: 0,
      parameter: {
        page: 1,
        page_size: 10,
        type: this.type,
        keyword: null
      },
      datas: [],
      advertiser_ids: [],
      myActives: [],
      firstTime: true,
      aa: null
    }
  },
  created() {
    window.aa = this
    this.getChannelBoundAccount()
    setTimeout(() => {
      this.getAdvertiserList(this.id)
    }, 100)
  },
  methods: {
    getRowKeys(row) {
      return row.account_id // 每条数据的唯一识别值
    },
    zhuanhaun(arr = []) {
      for (let i = 0; i < arr.length; i++) {
        const infin = arr[i].time_range.filter(item => item.end_time === '2999-01-01')
        this.myActives.push({
          account_id: arr[i].account_id,
          account_name: arr[i].account_name,
          date: arr[i].time_range.map(item => [item.start_time, item.end_time]).filter(item => item[1] !== '2999-01-01'),
          control: false,
          control1: false,
          infiniteStart: infin.length ? infin[0].start_time : null // 存储无限大的开始时间
        })
      }
    },
    handleSelect(item1) {
      this.selectData.forEach((item) => {
        if (item.account_id === this.acID) {
          item.jihua = item1.campaign_name
          item.campaign_id = item1.campaign_id
        }
      })
    },
    handleChange(value) {
      const item = this.selectData.filter((item) => {
        return this.acID === item.account_id
      })
      if (item.length && item[0].campaign_id) {
        (item[0].campaign_id !== value) && (item[0].campaign_id = undefined)
      }
    },

    // 获取渠道绑定的账号
    async getChannelBoundAccount() {
      if (!this.identical) {
        return
      }
      const data = await getTheAccountNumber(this.id)
      this.zhuanhaun(data.data.list)
    },

    // 处理搜索的输入内容
    handleParams(value) {
      const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/img
      this.parameter.keyword = value.replace(str, ',')

      const str1 = /(,){1,}/img
      this.parameter.keyword = this.parameter.keyword.replace(str1, ',')
    },

    // 获取广告主列表
    async getAdvertiserList() {
      this.isLoading = true
      const datas = await advertiserList(this.parameter)
      this.isLoading = false
      this.total = datas.data.count
      this.datas = datas.data.list
      this.toggleSelection()
    },

    // 绑定广告主
    async myBinAdvertisement() {
      if (!this.myActives || !this.myActives.length) {
        return
      }
      const obj = {}
      let errAccount_id = null
      let errTips = null

      // 做判断处理
      for (let i = 0; i < this.myActives.length; i++) {
        // 判断每项时间是否都有填
        this.myActives[i].date.forEach((item, index) => {
          if (!item || item.length < 1) {
            errAccount_id = this.myActives[i].account_id
            errTips = `${errAccount_id}账号中 时间必须填`
          }

          // 判断每项中时间是否有重叠
          this.myActives[i].date.forEach((item1, index1) => {
            if (index1 !== index && item && item.length > 1 && item1 && item1.length > 1) {
              if (this.isDateIntersection(item[0], item[1], item1[0], item1[1])) {
                errAccount_id = this.myActives[i].account_id
                errTips = `${errAccount_id}账号中 时间不能包含重叠`
              }
            }
          })

          if (this.myActives[i].infiniteStart && this.isDateIntersection(this.myActives[i].infiniteStart, '2999-01-01', item[0], item[i])) {
            errAccount_id = this.myActives[i].account_id
            errTips = `${errAccount_id}账号中 时间不能包含重叠`
          }
        })

        if (errAccount_id || errTips) {
          break
        }
      }

      // 判断条件是否不符合
      if (errAccount_id || errTips) {
        this.$message({
          message: errTips,
          type: 'warning'
        })
        return
      }

      // 组装数据
      this.myActives.forEach((item, index) => {
        obj[item.account_id] = []
        this.myActives[index].date.forEach(item1 => obj[item.account_id].push({ start_time: item1[0], end_time: item1[1] }))
        item.infiniteStart && obj[item.account_id].push({ start_time: item.infiniteStart, end_time: '2999-01-01' })
      })

      await bindAdvertisers({
        id: this.id,
        advertiser_type: this.parameter.type,
        advertiser_id: obj
      })
      this.$message({
        message: '绑定成功',
        type: 'success'
      })
      this.$emit('confirm')
    },

    // 获取广告主列表
    fetchAvertiserList(obj) {
      this.parameter.page = obj.page
      this.parameter.page_size = obj.limit
      this.getAdvertiserList()
    },
    confirm() {
      this.myBinAdvertisement()
    },

    // 搜索
    search() {
      this.fetchAvertiserList({ page: 1, limit: this.parameter.page_size })
    },

    // 重置
    reset() {
      this.parameter.keyword = null
    },

    // 清空
    clearSelect() {
      this.reset()
    },

    handleSelectionChange(a, item) {
      const bol = !!this.myActives.filter(item1 => +item.account_id === +item1.account_id).length

      if (bol) {
        // 过滤掉
        this.myActives = this.myActives.filter(item1 => +item.account_id !== +item1.account_id)
      } else {
        // 添加
        this.myActives.push({ ...item, date: [null], control: false, control1: false })
        // control为控制左边表格日期是否展开    control1为控制有边表格日期是否展开
      }
    },

    // 关闭
    close() {
      this.parameter = {
        page: 1,
        page_size: 10,
        type: this.id,
        keyword: null
      }
      this.$emit('colse')
    },

    /**
     * account_id   唯一值
     * type         加或减
     */
    processingMultipleTimes(account_id, type) {
      const index = this.myActives.findIndex(item => +item.account_id === +account_id)

      if (type === 'reduce') {
        // 减
        this.myActives[index].date.length > 1 && this.myActives[index].date.pop() // 截取掉最后一个
      } else {
        // 加
        this.myActives[index].date.length < 5 && this.myActives[index].date.push(null) // 添加一个
      }
    },

    // 处理默认选中
    toggleSelection() {
      for (let i = 0; i < this.datas.length; i++) {
        for (let k = 0; k < this.myActives.length; k++) {
          // eslint-disable-next-line eqeqeq
          if (this.datas[i].account_id == this.myActives[k].account_id) {
            this.$refs.multipleTable.toggleRowSelection(this.datas[i])
          }
        }
      }
    },

    // 删除时间
    deleteDate(account_id, index) {
      const index1 = this.myActives.findIndex(item => +item.account_id === +account_id)
      const s = this.myActives[index1].date.filter((item, index1) => {
        return +index1 !== (index - 1)
      })
      this.myActives[index1].date = s
    },

    // 判断两个日期段之间是否有交集（是否有重叠日期范围）
    isDateIntersection(start1, end1, start2, end2) {
      const startdate1 = new Date(start1.replace('-', '/').replace('-', '/'))
      const enddate1 = new Date(end1.replace('-', '/').replace('-', '/'))

      const startdate2 = new Date(start2.replace('-', '/').replace('-', '/'))
      const enddate2 = new Date(end2.replace('-', '/').replace('-', '/'))

      if (startdate1 >= startdate2 && startdate1 <= enddate2) { return true }
      if (enddate1 >= startdate2 && enddate1 <= enddate2) { return true }
      if (startdate1 <= startdate2 && enddate1 >= enddate2) { return true }

      return false
    }
  }
}
</script>

<style lang="less" scoped>
.center-container {
  margin-top: 20px;
  display: flex;
  .center-left {
    width: 70%;
  }
  .center-right {
    margin-left: 25px;
    // width: 500px;
    // max-height: 500px;
    overflow: auto;
    td {
      padding: 4px;
    }
  }

  .input{
    height: 30px;
    width: 69px;
    padding-left: 5px;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
  }
}
 ::v-deep .el-popper[x-placement^=bottom]{
		width:400px !important;
	}
 ::v-deep .center-container .center-left{
      width: 60%;
 }
 .titip{
    width: 70px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}
/deep/ .el-date-editor{
  width: 228px;
  margin: 3px 0px;
}

.additionAndSubtraction{
  font-size: 20px; margin: 0px 5px; margin-top:3px;cursor: pointer;
}

/deep/ .infinite .el-date-editor{
  width: 141px;
}

</style>
<style>

</style>

